import React from "react";

const veriSorumlusu = [
  { label: "Veri Sorumlusu", value: "Bursa Trabzon Kültür ve Yardımlaşma Derneği" },
  { label: "Adres", value: "Konak, Barış Sk. No:1/1, 16110 Nilüfer/Bursa" },
  { label: "Telefon", value: "0533 815 16 61" },
  { label: "E-posta", value: "info@bursatrabzonlulardernegi.org" },
];

const SectionTitle: React.FC<{ no: number; children: React.ReactNode }> = ({ no, children }) => (
  <h2 className="text-xl font-bold text-text-primary mb-3 mt-10 flex items-center gap-3">
    <span className="w-7 h-7 rounded-full bg-brand-bordo/10 text-brand-bordo text-sm font-bold flex items-center justify-center flex-shrink-0">
      {no}
    </span>
    {children}
  </h2>
);

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-text-muted text-sm leading-relaxed mb-3">{children}</p>
);

const Bullets: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5 mb-3 text-text-muted text-sm leading-relaxed">
    {items.map((it, i) => (
      <li key={i}>{it}</li>
    ))}
  </ul>
);

const SubTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h3 className="font-semibold text-text-primary text-sm mt-4 mb-2">{children}</h3>
);

const GizlilikPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">
    {/* Hero */}
    <div className="bg-gradient-to-br from-[#0F172A] to-[#1A2540] py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Yasal
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">
          Gizlilik Politikası ve KVKK Aydınlatma Metni
        </h1>
        <p className="text-white/70 max-w-2xl mx-auto leading-relaxed">
          Kişisel verilerinizin korunması bizim için önemlidir.
        </p>
      </div>
    </div>

    {/* İçerik */}
    <section className="py-12 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs text-text-soft mb-6">Son güncelleme: 30 Haziran 2026</p>

          <P>
            Bursa Trabzon Kültür ve Yardımlaşma Derneği ("Dernek", "biz") olarak, web sitemiz ve
            mobil uygulamamız ("Uygulama") üzerinden işlediğimiz kişisel verilerinizin güvenliğine
            önem veriyoruz. Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK")
            kapsamında veri sorumlusu sıfatıyla sizi bilgilendirmek amacıyla hazırlanmıştır.
          </P>

          {/* 1 */}
          <SectionTitle no={1}>Veri Sorumlusu</SectionTitle>
          <div className="border border-border-light rounded-xl overflow-hidden mb-3">
            {veriSorumlusu.map((row, i) => (
              <div
                key={row.label}
                className={`flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 px-4 py-3 text-sm ${
                  i % 2 === 0 ? "bg-bg-surface" : "bg-bg-page"
                }`}
              >
                <div className="font-semibold text-text-primary sm:w-40 flex-shrink-0">{row.label}</div>
                <div className="text-text-muted">{row.value}</div>
              </div>
            ))}
          </div>

          {/* 2 */}
          <SectionTitle no={2}>İşlenen Kişisel Veriler</SectionTitle>
          <P>
            Uygulamamızı ve hizmetlerimizi kullanmanız sırasında aşağıdaki kişisel verileriniz
            işlenebilmektedir:
          </P>
          <SubTitle>Üyelik ve kimlik bilgileri</SubTitle>
          <Bullets
            items={[
              "Ad ve soyad",
              "Telefon numarası",
              "Üye numarası ve üyelik tarihi",
              "Doğum tarihi",
              "Üyelik durumu",
            ]}
          />
          <SubTitle>Hesap ve giriş bilgileri</SubTitle>
          <Bullets
            items={[
              "Google ile giriş yapmanız hâlinde: Google hesabınıza ait ad, e-posta adresi ve profil fotoğrafı",
              "Hesabınızı doğrulamak için kullanılan kimlik bilgileri",
            ]}
          />
          <SubTitle>İşlem ve talep bilgileri</SubTitle>
          <Bullets
            items={[
              "Anlaşmalı kurum avantaj başvurularınız",
              "Etkinlik kayıt ve katılım talepleriniz",
              "Üyelik başvuru talepleriniz",
              "İletişim formu üzerinden ilettiğiniz mesajlar",
            ]}
          />
          <P>
            Uygulama, T.C. kimlik numarası gibi özel nitelikli kişisel verileri toplamamakta ve
            saklamamaktadır.
          </P>

          {/* 3 */}
          <SectionTitle no={3}>Kişisel Verilerin İşlenme Amaçları</SectionTitle>
          <P>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</P>
          <Bullets
            items={[
              "Dernek üyeliğinizin oluşturulması, yönetilmesi ve sürdürülmesi",
              "Üye kimliğinizin doğrulanması ve hesabınıza güvenli erişim sağlanması",
              "Etkinlik, duyuru ve faaliyetlerimiz hakkında sizi bilgilendirmek",
              "Anlaşmalı kurum avantajlarından yararlanmanızın sağlanması",
              "Etkinlik kayıt ve başvuru süreçlerinin yürütülmesi",
              "İletişim talepleriniz ile sorularınızın yanıtlanması",
              "Yasal yükümlülüklerimizin yerine getirilmesi",
            ]}
          />

          {/* 4 */}
          <SectionTitle no={4}>Kişisel Verilerin İşlenmesinin Hukuki Sebepleri</SectionTitle>
          <P>
            Kişisel verileriniz KVKK'nın 5. maddesinde belirtilen aşağıdaki hukuki sebeplere
            dayanılarak işlenmektedir:
          </P>
          <Bullets
            items={[
              "Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması (üyelik ilişkisi)",
              "Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması",
              "İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için zorunlu olması",
              "Açık rızanızın bulunması (gerekli hâllerde)",
            ]}
          />

          {/* 5 */}
          <SectionTitle no={5}>Kişisel Verilerin Aktarılması</SectionTitle>
          <P>
            Hizmetlerimizin sağlanabilmesi için verileriniz, altyapı ve barındırma hizmeti aldığımız
            Google LLC tarafından sağlanan Firebase platformu üzerinde işlenmekte ve saklanmaktadır.
            Bu kapsamda verileriniz, sunucuların bulunduğu yurt dışı lokasyonlarda (Avrupa Birliği /
            Frankfurt) barındırılabilmektedir.
          </P>
          <P>
            Verileriniz, yukarıda belirtilen altyapı sağlayıcısı dışında, yasal olarak yetkili kamu
            kurum ve kuruluşları haricinde üçüncü kişilerle paylaşılmamakta, ticari amaçla
            satılmamakta veya kiralanmamaktadır.
          </P>

          {/* 6 */}
          <SectionTitle no={6}>Kişisel Verilerin Saklanma Süresi</SectionTitle>
          <P>
            Kişisel verileriniz, üyeliğiniz devam ettiği sürece ve ilgili mevzuatta öngörülen yasal
            saklama süreleri boyunca saklanır. Üyeliğinizin sona ermesi ve yasal saklama sürelerinin
            dolması hâlinde verileriniz silinir, yok edilir veya anonim hâle getirilir.
          </P>

          {/* 7 */}
          <SectionTitle no={7}>Üçüncü Taraf Hizmetleri</SectionTitle>
          <P>
            Uygulamamız, Google hesabıyla giriş özelliği için Google'ın kimlik doğrulama
            hizmetlerini kullanmaktadır. Google ile giriş yaptığınızda, Google'ın gizlilik politikası
            da geçerli olur. Daha fazla bilgi için Google'ın gizlilik politikasını inceleyebilirsiniz.
          </P>

          {/* 8 */}
          <SectionTitle no={8}>İlgili Kişi Olarak Haklarınız</SectionTitle>
          <P>
            KVKK'nın 11. maddesi uyarınca, veri sorumlusuna başvurarak aşağıdaki haklarınızı
            kullanabilirsiniz:
          </P>
          <Bullets
            items={[
              "Kişisel verilerinizin işlenip işlenmediğini öğrenme",
              "İşlenmişse buna ilişkin bilgi talep etme",
              "İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme",
              "Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme",
              "Eksik veya yanlış işlenmişse düzeltilmesini isteme",
              "Silinmesini veya yok edilmesini isteme",
              "Düzeltme, silme ve yok etme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme",
              "İşlenen verilerin münhasıran otomatik sistemlerle analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme",
              "Kanuna aykırı işleme sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme",
            ]}
          />
          <P>
            Bu haklarınızı kullanmak için yukarıda yer alan adres veya e-posta üzerinden bizimle
            iletişime geçebilirsiniz.
          </P>

          {/* 9 */}
          <SectionTitle no={9}>Hesap ve Veri Silme Talebi</SectionTitle>
          <P>
            Hesabınızın ve ilgili kişisel verilerinizin silinmesini talep etmek isterseniz,{" "}
            <a href="mailto:info@bursatrabzonlulardernegi.org" className="text-brand-bordo font-semibold hover:underline">
              info@bursatrabzonlulardernegi.org
            </a>{" "}
            adresine talebinizi iletebilirsiniz. Talebiniz, yasal saklama yükümlülüklerimiz saklı
            kalmak kaydıyla en kısa sürede sonuçlandırılır.
          </P>

          {/* 10 */}
          <SectionTitle no={10}>Değişiklikler</SectionTitle>
          <P>
            Bu Gizlilik Politikası ve Aydınlatma Metni, gerekli görüldüğünde güncellenebilir.
            Güncellemeler bu sayfada yayımlandığı tarihte yürürlüğe girer.
          </P>

          {/* İletişim */}
          <div className="mt-10 p-5 rounded-xl bg-bg-surface border border-border-light text-sm text-text-muted">
            İletişim için:{" "}
            <a href="mailto:info@bursatrabzonlulardernegi.org" className="text-brand-bordo font-semibold hover:underline">
              info@bursatrabzonlulardernegi.org
            </a>{" "}
            ·{" "}
            <a href="tel:05338151661" className="text-brand-bordo font-semibold hover:underline">
              0533 815 16 61
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default GizlilikPage;
